import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators';
import {containerStyles, normalizeStyles} from "@webs/components-library/theming";
import {ifDefined} from "lit/directives/if-defined.js";

@customElement('webs-content-quote-card')
export class ContentQuoteCard extends LitElement {

  static styles = [
    normalizeStyles,
    containerStyles,
    css`
      .m-content-quote-card {
        width: 100%;
        position: relative;
        border-radius: .6rem;
        display: block;
        padding: 0.2rem 0.6rem;
        height: 100%;
      }

      .gradient-orange-pink {
        background: linear-gradient( 216.4deg, var(--color-orange) 22.12%, var(--color-pink) 110.96%);
      }

      .gradient-blue-green{
        background: linear-gradient(225.83deg, var(--color-blue) 1.74%, var(--color-green) 132.93%);
      }

      .gradient-blue-violet {
        background: linear-gradient(225.83deg, var(--color-pink) -30.72%, var(--color-blue) 96.47%);
      }

      .gradient-orange {
        background: linear-gradient(213.32deg, var(--color-dark-pink) -36.98%, var(--color-orange) 80.33%);
      }

      .m-content-quote-card__quote + .m-content-quote-card__quoter {
        margin-top: 1.2rem;
      }

      .m-content-quote-card__quoter-details--quoter-name {
        font-size: 0.7rem;
        font-family: var(--font-family-alternative);
        font-weight: var(--font-weight-strong);
        line-height: 1.3;
        margin: 0;
        text-transform: uppercase;
        color: var(--color-white);
      }

      .m-content-quote-card__quote {
        margin-top: 0;
        color: var(--color-white);
        font-size: 1.2rem;
        line-height: 1.3;
        font-weight: var(--font-weight-base);
      }

      .m-content-quote-card__wrapper {
         margin: 2.2rem 0.2rem 0 0.2rem;
      }

      .m-content-quote-card__quoter--avatar {
        border-radius: 50%;
        height: 48px;
        object-fit: cover;
        margin-right: .8rem;
        width: 48px;
      }

      .m-content-quote-card__quoter {
        display: flex;
      }

      .m-content-quote-card__quoter-details p {
        margin: 0;
      }

      .m-content-quote-card__quoter-details p:nth-of-type(n+2){
        margin: 3px 0 0;
      }

      .m-content-quote-card__quoter-details--extra-info {
        color: var(--color-white);
        font-family: var(--font-family-alternative);
        font-size: .7rem;
        font-weight: var(--font-weight-base);
        line-height: 1.3;
      }

      .m-content-quote-card__logo {
        display: flex;
        justify-content: flex-end;
        margin-top: 0.4rem;
      }

      .m-content-quote-card__logos {
        width: 100%;
        margin-top: 2.5rem;
        margin-bottom: 0;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
      }

      @media only screen and (min-width: 576px){
        .m-content-quote-card {
          padding: 1.2rem 1.6rem;
        }
      }
    `
  ];

  @property()
  quote: string;

  @property()
  avatar: string[];

  @property({attribute: 'quoter-name'})
  quoterName: string;

  @property({attribute: 'extra-info'})
  extraInfo: string;

  @property()
  gradient: string;

  @property()
  logo: string;

  protected render(): unknown {
    return html`
      <div part="quote-card" class="m-content-quote-card ${this.gradient ? 'gradient-' + this.gradient : ''}">
        ${this.logo ? html`
          <div class="m-content-quote-card__logo">
            <img src="${this.logo}" alt="Logo" loading="lazy" width="90">
          </div>
        ` : ''}
        <div part="quote" class="m-content-quote-card__wrapper">
          ${this.quote ? html`<p class="m-content-quote-card__quote">${this.quote}</p>` : ''}

          ${this.avatar || this.quoterName || this.extraInfo ? html`
            <div class="m-content-quote-card__quoter">
              <img class="m-content-quote-card__quoter--avatar" src="${ifDefined(this.avatar)}" alt="${this.quoterName}"
                   loading="lazy" width="48">

              ${this.quoterName || this.extraInfo ? html`
                <div class="m-content-quote-card__quoter-details">
                  ${this.quoterName ? html`<p class="m-content-quote-card__quoter-details--quoter-name">
                    ${this.quoterName}</p>` : ''}
                  ${this.extraInfo ? html`<p class="m-content-quote-card__quoter-details--extra-info">
                    ${this.extraInfo}</p>` : ''}
                </div>
              ` : ''}
            </div>

          ` : ''}
        </div>
        <div class="m-content-quote-card__logos">
          <slot name="header-logo"></slot>
        </div>

      </div>
    `

  }
}


